import { render, staticRenderFns } from "./InstrumentsPage.vue?vue&type=template&id=214ac904&scoped=true&"
import script from "./InstrumentsPage.vue?vue&type=script&lang=js&"
export * from "./InstrumentsPage.vue?vue&type=script&lang=js&"
import style0 from "./InstrumentsPage.vue?vue&type=style&index=0&id=214ac904&lang=scss&scoped=true&"
import style1 from "./InstrumentsPage.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "214ac904",
  null
  
)

export default component.exports